import React from "react";
import DynamicForm from "../../components/DynamicForm/DynamicForm";
import { getStoredData } from "../../json/fecthData";

const UserManagementCreate = () => {
  // Fetch stored user data
  const userData = getStoredData()?.[1] || {}; // Ensure userData is an object


  return (
    <div>
      <h2>Create New {userData.TitleUser}</h2>
      <DynamicForm
        fields={userData.AdminUser} // Pass dynamic fields
        apiUrl={userData.ApiUserRegister} // Use correct API URL
        successRedirect={userData.RedirectAdminUser} // Redirect after successful submission
      />
    </div>
  );
};

export default UserManagementCreate;
